export const PAGE_TITLE_HEADER_TEXT_ID = 'pageTitleHeaderText';

export const ROUTES = Object.freeze({
  tools: '/ltimanagement/tools',
  links: '/ltimanagement/links',
  importLogs: '/import-logs',
  createTool: '/ltimanagement/tool/create',
  createLink: '/ltimanagement/link/create',
});

export const REG_EXP = Object.freeze({
  lettersNumbersDashes: /^[a-zA-Z0-9-]+$/,
  /**
   * Regular expression for validating a Tool Redirect URL.
   * Allows multi-label hosts (including labels that start with a digit, e.g. build.1edtech.org)
   * and {0}, {1}, {2}, etc. as dynamic path parameters.
   */
  toolRedirectUrl:
    // eslint-disable-next-line no-useless-escape
    /^(https?:\/\/(?:[a-zA-Z0-9_-]+\.)+[a-zA-Z]{2,})(:\d+)?([\/?[a-zA-Z0-9\-._~:\/?#[\]@!$&'(){}*+,;=]*)?$/,
});
